import { getSupabase } from './supabase/client';
import { disconnectGoogle } from './googleAuth';
import { disconnectMicrosoft } from './microsoftAuth';
import { apiRequest } from './api';
import { t } from './language';

/**
 * Hesabı kalıcı olarak siler (Ayarlar > Genel > Hesabı sil).
 *
 * Silme sunucuda yapılıyor (`/api/v1/account/delete`): abonelik iptali,
 * botların durdurulması, buluttaki dosyalar ve bütün kayıtlar. Burada yalnızca
 * bu bilgisayardaki oturum ve bağlı hesap anahtarları temizleniyor. Bu
 * bilgisayardaki yerel ses dosyaları kullanıcının — dokunulmuyor.
 */
export async function deleteMyAccount(confirmEmail: unknown): Promise<void> {
  if (typeof confirmEmail !== 'string' || !confirmEmail.trim() || confirmEmail.length > 320) {
    throw new Error(t('Onay için e-posta adresini yaz.', 'Type your email address to confirm.'));
  }

  await apiRequest('POST', '/api/v1/account/delete', {
    body: { confirmEmail: confirmEmail.trim() },
    timeoutMs: 120_000,
  });

  // Sunucuda kullanıcı artık yok — oturumu yalnızca bu bilgisayarda kapat.
  await getSupabase().auth.signOut({ scope: 'local' }).catch(() => {});
  await disconnectGoogle().catch(() => {});
  await disconnectMicrosoft().catch(() => {});
}
